<template>
  <section
    class="app-main bg-background"
    :class="{ 'd-flex': key === '/dashboard/' }"
  >
    <router-view :key="key" />
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const key = computed(() => route.path)
</script>

<style lang="scss" scoped>
.app-main {
  width: 100%;
  position: relative;
  height: 100%;
}

.sidebar-container + .app-main {
  padding-left: var(--little-sidebar-width);
}

@media print {
  .app-main {
    background-color: #ffffff;
  }
}
</style>
